export enum ShippingMethodType {
  BULK = 'bulk',
  DIRECT = 'direct',
}

export type InviteFlowReducerState = {
  shippingMethod: ShippingMethodType | null;
};

export type InviteFlowReducerAction = {
  type: 'setShippingMethod';
  shippingMethod: ShippingMethodType;
};

export type InvalidEmailReason = 'likely_typo' | 'malformed';

export type InvalidEmailEntry = {
  index: number;
  reason?: InvalidEmailReason;
};

export type InvalidEmailError = {
  email: string;
  reason?: InvalidEmailReason;
};
